export const renderTitleModal = (props) => {
    const { action, newOrderModel, docFilter } = props;
    let complemento = "";
    let authorized = newOrderModel.isDocumentWithAuthorization;

    if (authorized) {
        complemento = "[Autorizado]";
    }

    let title = '';

    switch (newOrderModel.OriginDocumentCreate) {
        case 'quotations':
            title = 'Oferta de Venta ' + complemento;
            break;
        case 'orderSales':
            title = 'Orden de Venta ' + complemento;
            break;
        case 'deliveries':
            title = 'Entrega ' + complemento;
            break;
        case 'invoice':
            title = 'Factura ' + complemento;
            break;
        case 'invoiceAdvance':
            title = 'Factura de Anticipo ' + complemento;
            break;
        case 'purchaseDownPayments':
            title = 'Factura de Anticipo de provedores ' + complemento;
            break;
        case 'return':
            title = 'Devolución ' + complemento;
            break;
        case 'purchaseReturn':
            title = 'Devolución de Mercancía ' + complemento;
            break;
        case 'debitNote':
            title = 'Nota de Débito ' + complemento;
            break;
        case 'creditNote':
            title = 'Nota de Crédito ' + complemento;
            break;
        case 'payment':
            title = 'Pagos Recibidos ';
            break;
        case 'transfers':
            title = 'Traslado de Mercancía ' + complemento;
            break;
        case 'transfersRequest':
            title = 'Solicitud de Traslado ' + complemento;
            break;
        case 'transfersEntry':
            title = 'Entrada de Mercancía ' + complemento;
            break;
        case 'transfersOutput':
            title = 'Salida de Mercancía ' + complemento;
            break;
        case 'invoiceAuthorization':
            title = 'Borrador [Pendiente]  ';
            break;
        case 'invoiceBorrador':
            title = 'Borrador [Autorizado]  ';
            break;
        case 'PurchaseOrder':
            title = 'Orden de Compra  ' + complemento;
            break;
        case 'GoodsReceipt':
            title = 'Entrada de Mercancía ' + complemento;
            break;
        case 'SalesHelmets':
            title = 'Entrada de Mercancía Cascos';
            break;
        case 'ExitHelmets':
            title = 'Salida de Mercancía Cascos';
            break;
        case 'PurchaseRequest':
            title = 'Solicitud de Compra  ' + complemento;
            break;
        case 'inventoryRevaluation':
            title = 'Revalorización de Inventario ' + complemento;
            break;
        case 'purchaseInvoice':
            title = 'Factura de Proveedores';
            break;
        case 'purchaseCreditNotes':
            title = 'Nota de crédito Proveedores';
            break;
        case 'outgoingPayment':
            title = 'Pagos Efectuados';
            break;
        case 'invoiceReserve':
            title = 'Factura de reserva de clientes';
            break;
        case 'middleware':
            if (newOrderModel.ObjType === '22') {
                title = 'Orden de Compra';
            } else if (newOrderModel.ObjType === '18') {
                title = 'Factura de Proveedores [Preliminar]';
            }
            break;
        case 'citibanamex':
            title = docFilter === 'OPCH' ? 'Factura de proveedor' : 'Orden de Compra';
            break;
        case 'reportSelectionCriteria':
            title = 'Recomendación de Pedido: Criterios de selección ' + complemento;
            break;
        case 'landedCosts':
            title = 'Precio de Entrega';
            break;
        case 'PurchaseQuotation':
            title = 'Oferta de Compra';
            break;
        case 'PurchaseQuotationDraft':
            title = 'Oferta de Compra (Borrador)';
            break;
        case 'draft':
            title = 'Documento Preliminar';
            break;
        default:
    }

    if (action === 1) {
        title = 'Nuevo(a) ' + title;
    }

    if (action === 2) {
        title = 'Detalle de ' + title;
    }

    return title;
};